"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ReportPanel = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactVirtualized = require("react-virtualized");

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _reactRedux = require("react-redux");

var _ReportHeader = _interopRequireDefault(require("../components/ReportHeader"));

var _NumberFormatter = _interopRequireDefault(require("../modules/NumberFormatter"));

var _DateFormatter = _interopRequireDefault(require("../modules/DateFormatter"));

var _mapActions = require("../actions/mapActions");

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/* const ReportConfig = {
  fields: [{
    name: 'area_name',
    label: 'County Name',
  }, {
    name: 'cust_a',
    label: 'Customers Affected',
    icon: 'exclamation-triangle',
  }],
}; */


var ReportPanel = function ReportPanel(_ref) {
  var _sc5Report$totals, _sc5Report$totals2, _sc5Report$totals3, _sc5Report$totals4;

  var deviceType = _ref.deviceType,
      sc5Report = _ref.sc5Report,
      config = _ref.config,
      updateIntervalText = _ref.updateIntervalText;
  var reportAreas = sc5Report.areas;
  var dispatch = (0, _reactRedux.useDispatch)();

  var headerRenderer = function headerRenderer(_ref2) {
    var dataKey = _ref2.dataKey,
        label = _ref2.label,
        sortBy = _ref2.sortBy,
        sortDirection = _ref2.sortDirection;
    var children = [/*#__PURE__*/_react.default.createElement("span", {
      key: "label",
      title: typeof label === 'string' ? label : undefined
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: 'header-icon'
    }, dataKey === 'cust_a' && deviceType !== 'mobile' && /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'exclamation-triangle'],
      color: 'white'
    }), dataKey === 'cust_s' && deviceType !== 'mobile' && /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'user'],
      color: 'white'
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "header-label device-".concat(deviceType)
    }, label), /*#__PURE__*/_react.default.createElement("span", {
      className: 'sort-indicator'
    }, sortBy === dataKey && sortDirection === 'ASC' && /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'caret-up'],
      color: 'white'
    }), sortBy === dataKey && sortDirection === 'DESC' && /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
      icon: ['fas', 'caret-down'],
      color: 'white'
    })))];
    return children;
  };

  var rowRenderer = function rowRenderer(_ref3) {
    var className = _ref3.className,
        columns = _ref3.columns,
        index = _ref3.index,
        key = _ref3.key,
        onRowClick = _ref3.onRowClick,
        onRowDoubleClick = _ref3.onRowDoubleClick,
        onRowMouseOut = _ref3.onRowMouseOut,
        onRowMouseOver = _ref3.onRowMouseOver,
        onRowRightClick = _ref3.onRowRightClick,
        rowData = _ref3.rowData,
        style = _ref3.style;
    var a11yProps = {
      'aria-rowindex': index + 1
    };

    if (onRowClick || onRowDoubleClick || onRowMouseOut || onRowMouseOver || onRowRightClick) {
      a11yProps['aria-label'] = 'row';
      a11yProps.tabIndex = 0;

      if (onRowClick) {
        a11yProps.onClick = function (event) {
          return onRowClick({
            event: event,
            index: index,
            rowData: rowData
          });
        };
      }

      if (onRowDoubleClick) {
        a11yProps.onDoubleClick = function (event) {
          return onRowDoubleClick({
            event: event,
            index: index,
            rowData: rowData
          });
        };
      }

      if (onRowMouseOut) {
        a11yProps.onMouseOut = function (event) {
          return onRowMouseOut({
            event: event,
            index: index,
            rowData: rowData
          });
        };
      }

      if (onRowMouseOver) {
        a11yProps.onMouseOver = function (event) {
          return onRowMouseOver({
            event: event,
            index: index,
            rowData: rowData
          });
        };
      }

      if (onRowRightClick) {
        a11yProps.onContextMenu = function (event) {
          return onRowRightClick({
            event: event,
            index: index,
            rowData: rowData
          });
        };
      }
    }

    return /*#__PURE__*/_react.default.createElement("div", _extends({}, a11yProps, {
      className: className,
      key: key,
      role: "row",
      style: style
    }), columns);
  };

  var _sortList = function _sortList(list, sortBy, sortDirection) {
    var sorted = list.sort(function (areaA, areaB) {
      if (sortBy === 'cust_a') {
        return areaA.cust_a.val - areaB.cust_a.val;
      }

      return areaA[sortBy].localeCompare(areaB[sortBy], undefined, {
        numeric: true
      });
    });

    if (sortDirection === 'ASC') {
      return sorted;
    }

    return sorted.reverse();
  };

  var cellRender = function cellRender(_ref4) {
    var cellData = _ref4.cellData,
        method = _ref4.method,
        formatter = _ref4.formatter,
        rowData = _ref4.rowData,
        dataKey = _ref4.dataKey,
        goToAreaCriteria = _ref4.goToAreaCriteria;
    var rawValue = method ? method(cellData) : cellData;
    var formattedValue = formatter ? formatter(rawValue) : rawValue;

    if (dataKey === 'area_name' && goToAreaCriteria) {
      return /*#__PURE__*/_react.default.createElement("button", {
        className: 'table-cell-inner-link',
        onClick: function onClick() {
          dispatch((0, _mapActions.goToArea)(goToAreaCriteria(rowData)));
        }
      }, formattedValue);
    }

    return /*#__PURE__*/_react.default.createElement("span", {
      className: 'table-cell-inner'
    }, formattedValue);
  };

  var _useState = (0, _react.useState)('ASC'),
      _useState2 = _slicedToArray(_useState, 2),
      sortDirection = _useState2[0],
      setSortDirection = _useState2[1];

  var _useState3 = (0, _react.useState)(config.reportFields[0].fieldName),
      _useState4 = _slicedToArray(_useState3, 2),
      sortBy = _useState4[0],
      setSortBy = _useState4[1];

  var _useState5 = (0, _react.useState)(_sortList(reportAreas, sortBy, sortDirection)),
      _useState6 = _slicedToArray(_useState5, 2),
      sortedList = _useState6[0],
      setSortList = _useState6[1];

  var _sort = function _sort(sortProps) {
    var sorted = _sortList(sortedList, sortProps.sortBy, sortProps.sortDirection);

    setSortList(sorted);
    setSortDirection(sortProps.sortDirection);
    setSortBy(sortProps.sortBy);
  };

  var _useState7 = (0, _react.useState)(sortedList),
      _useState8 = _slicedToArray(_useState7, 2),
      filteredList = _useState8[0],
      setFilteredList = _useState8[1];

  var _useState9 = (0, _react.useState)(''),
      _useState10 = _slicedToArray(_useState9, 2),
      filterTerm = _useState10[0],
      setFilterTerm = _useState10[1];

  (0, _react.useEffect)(function () {
    var newFilteredList = sortedList.filter(function (area) {
      if (!filterTerm) return true;
      if (filterTerm.length === 0) return true;
      return area.area_name.toLowerCase().indexOf(filterTerm.toLowerCase()) >= 0;
    });
    setFilteredList(newFilteredList);
  }, [filterTerm, sortedList, setFilteredList, sortBy, sortDirection]);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "report-panel device-".concat(deviceType)
  }, /*#__PURE__*/_react.default.createElement(_ReportHeader.default, {
    deviceType: deviceType,
    custA: ((_sc5Report$totals = sc5Report.totals) === null || _sc5Report$totals === void 0 ? void 0 : _sc5Report$totals.cust_a) ? sc5Report.totals.cust_a.val : 0,
    custS: ((_sc5Report$totals2 = sc5Report.totals) === null || _sc5Report$totals2 === void 0 ? void 0 : _sc5Report$totals2.cust_s) || 0,
    setFilterTerm: setFilterTerm
  }), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      flex: '1 1 auto'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactVirtualized.AutoSizer, null, function (_ref5) {
    var width = _ref5.width,
        height = _ref5.height;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactVirtualized.Table, {
      columnCount: 2,
      headerHeight: 50,
      height: height,
      rowCount: filteredList.length,
      rowGetter: function rowGetter(_ref6) {
        var index = _ref6.index;
        return filteredList[index % filteredList.length];
      },
      width: width === 0 ? 1 : width,
      rowHeight: 50,
      rowStyle: {
        alignItems: 'stretch',
        display: 'flex'
      },
      headerClassName: 'table-header',
      rowClassName: function rowClassName(_ref7) {
        var index = _ref7.index;
        return "report-row ".concat(index % 2 === 0 ? ' even' : ' odd');
      },
      rowRenderer: rowRenderer,
      sort: _sort,
      sortBy: sortBy,
      sortDirection: sortDirection,
      noRowsRenderer: function noRowsRenderer() {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: 'no-rows-message'
        }, /*#__PURE__*/_react.default.createElement("span", null, "No Data Available"));
      }
    }, config.reportFields.map(function (field, index) {
      return /*#__PURE__*/_react.default.createElement(_reactVirtualized.Column, {
        width: 400,
        dataKey: field.fieldName,
        label: field.label,
        flexGrow: index === 0 ? 1 : 0,
        headerRenderer: headerRenderer,
        headerClassName: "header-".concat(field.fieldName),
        className: "table-cell field-".concat(field.fieldName),
        cellRenderer: function cellRenderer(props) {
          return cellRender(_objectSpread(_objectSpread({}, props), {}, {
            method: field.method,
            formatter: field.formatter,
            goToAreaCriteria: config.goToAreaCriteria
          }));
        },
        key: field.fieldName
      });
    })));
  })), deviceType === 'mobile' && /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-footer device-".concat(deviceType)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "mobile-footer-inner device-".concat(deviceType)
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "Total Customers Affected \xA0 ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 500
    }
  }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, ((_sc5Report$totals3 = sc5Report.totals) === null || _sc5Report$totals3 === void 0 ? void 0 : _sc5Report$totals3.cust_a) || 0)))), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "Total Customers Served \xA0 ", /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 500
    }
  }, /*#__PURE__*/_react.default.createElement(_NumberFormatter.default, null, ((_sc5Report$totals4 = sc5Report.totals) === null || _sc5Report$totals4 === void 0 ? void 0 : _sc5Report$totals4.cust_s) || 0)))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "report-footer device-".concat(deviceType)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "report-footer-inner device-".concat(deviceType)
  }, /*#__PURE__*/_react.default.createElement("span", {
    style: {
      fontWeight: 500
    }
  }, "Last Updated: ", /*#__PURE__*/_react.default.createElement("span", null, /*#__PURE__*/_react.default.createElement(_DateFormatter.default, null, sc5Report.updatedAt), ". \xA0")), updateIntervalText && /*#__PURE__*/_react.default.createElement("span", null, updateIntervalText))));
};

exports.ReportPanel = ReportPanel;
ReportPanel.propTypes = {
  deviceType: _propTypes.default.string.isRequired,
  sc5Report: _propTypes.default.any.isRequired,
  config: _propTypes.default.any.isRequired,
  updateIntervalText: _propTypes.default.string
};
var _default = ReportPanel;
exports.default = _default;